<div class="filter">
  <div *ngIf="isTimeSeries" class="filter__time-series" [formGroup]="timeSeriesForm">
    <mat-form-field>
      <mat-label>Start Date <span class="text-red-600">*</span></mat-label>
      <input formControlName="startDate" matInput [matDatepicker]="startDatePicker" />
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>End Date <span class="text-red-600">*</span></mat-label>
      <input formControlName="endDate" matInput [matDatepicker]="endDatePicker" />
      <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <list-filter
    (filterChanged)="onListFilterChanged($event)"
    [queryFilters]="filters"
    [savedFilter]="{}"
    [onlyList]="true"
    [relatedToType]="isTimeSeries ? 'Project' : definition.related_to_type"
    listStyle="width: 100%"
    [promptRemove]="false"
    [allowRelatedObjectFields]="allowRelatedObjectFields"
    [fieldsFilterFn]="fieldsFilterFn"
    (filterRowsValidityChange)="onFilterRowsValidityChange($event)"
  ></list-filter>

  <div class="border-t border-gray-100 pt-2 mt-4 text-right">
    <ts-button variant="secondary" (click)="clear()" class="mr-2">Clear</ts-button>
    @if (isTimeSeries) {
      <ts-button
        [disabled]="isReportBusy || !isTimeSeriesFilterValid || (queryFilters?.length && !isFilterRowsValid)"
        (click)="apply()"
        [appAuthorize]="canApplyFilters"
        denyAction="disable"
        >Apply</ts-button
      >
    } @else {
      <ts-button
        [disabled]="!queryFilters?.length || !isFilterRowsValid || isReportBusy"
        (click)="apply()"
        [appAuthorize]="canApplyFilters"
        denyAction="disable"
        >Apply</ts-button
      >
    }
  </div>
</div>
